// extracted by mini-css-extract-plugin
export default {"form":"_5sXBq","message":"AaFBP","success":"ChPdR","error":"_2lliz","info":"yUwbk","submit":"-MWtd","agree":"xfWsi"};